import ReactTable from 'react-table-6';
import styled from 'styled-components';
import 'react-table-6/react-table.css';

const StyledReactTable = styled(ReactTable)`
    & .rt-thead.-header {
        box-shadow: none !important;

        & .rt-resizable-header-content, .rt-th div:not(.rt-resizer) {
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 24px;
            font-size: 12px;
        }

        & .rt-th {
            outline: none;
        }

        & .rt-th.-alignLeft div:not(.rt-resizer) {
            justify-content: left;
        }

        & .rt-th.-alignRight div:not(.rt-resizer) {
            justify-content: right;
        }

        & .rt-resizable-header, .rt-th {
            background-color: #E2E2E2;
        }
    }

    & .rt-tr[row-count="0"] {
        
        & .rt-expander {
        visibility: hidden;
        }

        & .rt-expandable {
            cursor: default;
        }
    }

    & .rt-tfoot {
        text-transform: uppercase;
    }
`;

export default StyledReactTable;



// WEBPACK FOOTER //
// ./src/components/molecules/StyledReactTable.js